import React from "react";
import { Box, Button, Typography } from "@mui/material";

interface BulkActionBarProps {
  selectedCount: number;
  onClear: () => void;
  onDelete: () => void;
  deleteLabel?: string;
}

const BulkActionBar: React.FC<BulkActionBarProps> = ({
  selectedCount,
  onClear,
  onDelete,
  deleteLabel = "Delete Selected",
}) => {
  if (selectedCount <= 0) return null;
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        p: 2,
        mb: 2,
        borderRadius: 2,
        background: "#fff7ed",
        border: "1px solid #fed7aa",
      }}
    >
      <Typography sx={{ fontSize: 14, fontWeight: 600, color: "#9a3412" }}>
        {selectedCount} selected
      </Typography>
      <Box sx={{ display: "flex", gap: 1 }}>
        <Button
          variant="text"
          size="small"
          onClick={onClear}
          sx={{ textTransform: "none", color: "#9a3412" }}
        >
          Clear
        </Button>
        <Button
          color="error"
          variant="contained"
          size="small"
          onClick={onDelete}
          sx={{ textTransform: "none" }}
        >
          {deleteLabel}
        </Button>
      </Box>
    </Box>
  );
};

export default BulkActionBar;
